import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import HelpArticleLink from '../../components/help-article-link';
import { linkIDs } from '../../services/link-service/links';

import { useSplitShipModalContext } from './split-ship-modal-context-provider';
import { SPLIT_SHIP_ACTIONS, useTrackSplitShipAction } from './event-tracking/use-track-split-ship-action';
import { modalMessages } from './messages';
import style from './split-ship-modal.module.less';

const SplitShipModalFooter = ({ onClose }) => {
  const { save, isSaving, splitRowId } = useSplitShipModalContext();

  const trackModalSave = useTrackSplitShipAction(SPLIT_SHIP_ACTIONS.MODAL_SAVE);
  const trackModalCancel = useTrackSplitShipAction(SPLIT_SHIP_ACTIONS.MODAL_CANCEL);
  const trackTutorialOpened = useTrackSplitShipAction(SPLIT_SHIP_ACTIONS.TUTORIAL_OPEN);

  const onCancel = useCallback(() => {
    onClose();
    trackModalCancel();
  }, [onClose, trackModalCancel]);

  const onSave = useCallback(() => {
    save();
    trackModalSave();
  }, [save, trackModalSave]);

  const isSplittingRow = !!splitRowId;

  return (
    <ModalFooter className={style.footer}>
      <FormattedMessage
        {...modalMessages.splitShipHelpArticle}
        values={{
          link: (chunks) => (
            <HelpArticleLink articleId={linkIDs.SplitShip} onClick={trackTutorialOpened}>
              {chunks}
            </HelpArticleLink>
          ),
        }}
      />
      <div className={style['action-button-container']}>
        <Button className={style.button} disabled={isSaving} onClick={onCancel} theme='tertiary'>
          <FormattedMessage {...modalMessages.splitShipModalCancelButton} />
        </Button>
        <Button
          className={style.button}
          disabled={isSaving || isSplittingRow}
          disabledTooltipMessage={isSplittingRow ? <FormattedMessage {...modalMessages.applyChangesTooltip} /> : undefined}
          onClick={onSave}
          theme='primary'
        >
          <FormattedMessage {...modalMessages.splitShipModalSaveButton} />
        </Button>
      </div>
    </ModalFooter>
  );
};

SplitShipModalFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { SplitShipModalFooter };
